export const useMenuStore = defineStore({
  id: 'menuStore',
  state: () => ({
    isOpen: false,
  }),
})
